export default __webpack_public_path__ + "static/team-photo-dfb608c484c0aa34478b9045a37c5c9d.webp";